module.exports = __webpack_public_path__ + "img/headset.44d05cc7.svg";